import { EsignTab } from '@/features/events/components/Detail/Tabs/EsignTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/esign')({
  component: EsignTab,
});
